











import { Vue, Prop, Component } from "vue-property-decorator";

// Enums/Data
import { ProvisionCategoryCodes } from "@/modules/web_hosting/data/enums";

@Component({
  components: {
    "provision-configurations-provider": () =>
      import(
        "@/components/app/admin/provisioning/provisionConfigurationsProvider.vue"
      ),
    "provision-configurations-listing": () =>
      import(
        "@/components/app/admin/provisioning/provisionConfigurationsListing.vue"
      ),
    "create-provision-configuration": () =>
      import(
        "@/components/app/admin/provisioning/createProvisionConfiguration.vue"
      )
  }
})
export default class WebHostingServersView extends Vue {
  // Props

  @Prop({ required: true })
  public categoryCode!: ProvisionCategoryCodes;
}
